import React, { PureComponent, Fragment } from 'react';
import { message, Button, Modal, Form, Input } from 'antd';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
import { FormComponentProps } from 'antd/es/form';

const { TextArea } = Input;
const api = services.api;

export interface CancelOrderProps {
    click: () => void;
    form: FormComponentProps['form'];
    entity: Entity;
}

export interface IState {
    visible: boolean;
}

class CancelOrderView extends PureComponent<CancelOrderProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            visible: false,
        };
        this.onAdd = this.onAdd.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    handleOk = (e?: any) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log(values);
                if (this.state.visible) {
                    api.put(
                        {
                            cancel_type: 'SERVICE',
                            cancel_reason: values.cancelReason,
                        },
                        {
                            apiPath: `/8001/order/${values.id}/order_cancel`,
                        }
                    )
                        .then((res: any) => {
                            message.success('取消成功');
                            this.setState({
                                visible: false,
                            });
                        })
                        .catch(errorHandle);
                }
            }
        });
    };

    handleCancel = () => {
        this.setState({
            visible: false,
        });
    };

    onAdd() {
        this.setState({
            visible: true,
        });
        if (this.state.visible) {
            this.handleOk();
        }
    }

    render() {
        const {
            form: { getFieldDecorator },
        } = this.props;

        return (
            <>
                <Fragment>
                    <Button style={{ width: 150 }} type="primary" onClick={() => this.onAdd()}>
                        问题订单取消
                    </Button>
                </Fragment>
                <Modal
                    title="问题订单取消"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    okText={'确定'}
                >
                    <Form layout="vertical">
                        <Form.Item label="取消单号">
                            {getFieldDecorator('id', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入取消单号',
                                    },
                                ],
                            })(<Input maxLength={30} />)}
                        </Form.Item>
                        <Form.Item label="取消原因">
                            {getFieldDecorator('cancelReason', {
                                rules: [
                                    {
                                        // required: true,
                                        message: '请输入取消原因',
                                    },
                                ],
                            })(
                                <TextArea
                                    rows={4}
                                    maxLength={300}
                                    placeholder="最多输入300个字符"
                                />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        );
    }
}

export const CancelOrder = Form.create()(CancelOrderView);
